import { KdsModal, KdsText, VStack } from "@kazaar-platform/design-system";
import { RiErrorWarningLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { type ModalConfirmProductChangeProps } from "./ModalConfirmProductChange.types";

export const ModalConfirmProductChange = ({
  isOpen,
  onOpenChange,
  onConfirm,
}: ModalConfirmProductChangeProps) => {
  const { t } = useTranslate();

  return (
    <KdsModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="md"
      dialogProps={{
        dialogHeaderProps: {
          title: t("expertMode.modalConfirmProductChange.title"),
          icon: RiErrorWarningLine,
        },
        content: (
          <VStack gap="sp-md">
            <KdsText size="subtitle-md">
              {t("expertMode.modalConfirmProductChange.description")}
            </KdsText>
          </VStack>
        ),
        dialogFooterProps: {
          buttonProps: [
            {
              children: t("buttons.cancel"),
              variant: "ghost",
              color: "neutral",
              onPress: onOpenChange,
            },
            {
              color: "error",
              children: t("buttons.confirm"),
              onPress: onConfirm,
            },
          ],
        },
      }}
    />
  );
};
